module.exports = __webpack_public_path__ + "static/media/logo-normal.ea72f4d5.svg";